module.exports = __webpack_public_path__ + "img/5.89cb046c.jpg";